export const GRIDCOLUMN =
  "80px 100px minmax(150px, 1fr) 120px 140px 120px 100px 100px 40px 40px";
